import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyx, wildSand} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: wildSand,
  },
  header: {
    paddingTop: indent * 0.1,
    paddingBottom: indent * 0.5,
  },
  titleText: {
    fontSize: 18,
    lineHeight: 26,
  },
  content: {
    paddingTop: indent * 0.05,
    paddingBottom: indent * 0.4,
  },
  globalProgressRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  monthAndDaysRow: {
    marginTop: indent * 0.75,
    flexDirection: 'row',
    alignItems: 'center',
  },
  tierSection: {
    marginTop: indent * 0.5,
  },
  pqvTitle: {
    marginTop: indent * 0.6,
    color: onyx,
    fontSize: 13,
    lineHeight: 17,
  },
  loadingBoxGlobalProgress: {
    height: 8,
    width: 170,
    borderRadius: 6,
  },
  loadingBoxGlobalLabel: {
    height: 18,
    width: 100,
  },
  loadingBoxMonth: {
    height: 20,
    width: 120,
  },
  loadingBoxDaysLeft: {
    height: 20,
    width: 75,
    marginLeft: indent * 0.3,
  },
  loadingBoxTierHeader: {
    height: 18,
    width: 160,
  },
  loadingBoxTierSlots: {
    marginTop: indent * 0.35,
    height: 48,
    width: 320,
    borderRadius: 12,
  },
  footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: indent * 0.6,
    paddingBottom: indent * 0.2,
  },
  footerLabelText: {
    color: onyx,
    fontSize: 14,
    lineHeight: 18,
  },
  loadingBoxEligibleThrough: {
    height: 18,
    width: 120,
  },
});
